import { AppLauncher } from '@capacitor/app-launcher'
import { getDevice } from 'framework7'
import { f7 } from 'framework7-vue'

import store from '@/js/store'

declare const __APP_VERSION__: string

const device = getDevice()
let updateDialog: ReturnType<typeof f7.dialog.create> | undefined

const showUpdateDialog = () => {
  if (updateDialog) return

  const text = `Medzičasom sme vydali majoritnú aktualizáciu aplikácie.
    Táto aktualizácia zmenila základné štruktúry na pozadí. Z dôvodu zachovania integrity aplikácie je ju nutné aktualizovať.
    Choď do svojho obchodu s aplikáciami cez tlačidlo nižšie a vykonaj aktualizáciu. Do tej doby bude aplikácia zablokovaná.`

  const buttons = []

  if (device.cordova) {
    if (device.ios) {
      buttons.push({
        text: 'Aktualizovať cez App Store',
        close: false,
        onClick: async () => {
          await AppLauncher.openUrl({ url: 'itms-apps://apps.apple.com/app/id6478879845' })
        },
      })
    } else if (device.android) {
      buttons.push({
        text: 'Aktualizovať cez Google Play',
        close: false,
        onClick: async () => {
          await AppLauncher.openUrl({ url: 'market://details?id=com.pelicantravel.pelikanecSK' })
        },
      })
    }
  }

  const dialog = f7.dialog.create({
    title: 'Je k dispozícii nová verzia aplikácie',
    text,
    buttons,
    destroyOnClose: false,
    closeByBackdropClick: false,
  })
  updateDialog = dialog
  const releaseDialog = () => {
    if (updateDialog === dialog) updateDialog = undefined
  }
  dialog.once('close', releaseDialog)
  dialog.once('beforeDestroy', releaseDialog)
  // Closing a queued Framework7 dialog does not emit a close event.
  const close = dialog.close.bind(dialog)
  dialog.close = (animate?: boolean) => {
    releaseDialog()
    return close(animate)
  }
  dialog.open()
}

export const checkForUpdate = async () => {
  const latestVersion = store.getters?.defaultSettings?.value?.latestFeBreakingChangeVersion || ''
  const currentVersion = __APP_VERSION__

  const isAppDeprecated = () => {
    const v1 = currentVersion.split('.').map(Number)
    const v2 = latestVersion.split('.').map(Number)

    for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
      const num1 = v1[i] || 0
      const num2 = v2[i] || 0

      if (num1 > num2) {
        return 1
      }
      if (num1 < num2) {
        return -1
      }
    }

    return 0
  }

  if (latestVersion && isAppDeprecated() === -1) {
    store.state.updateRequired = true
    showUpdateDialog()

    return true // Update is required
  }

  store.state.updateRequired = false
  return false // No update required
}
